// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planocontas_DestroyResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for planocontas/destroy endpoint
 *
 * Returns the deleted conta ID and confirmation
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planocontas_DestroyResponseDados {
id: number
deleted: boolean
}

export type Planocontas_DestroyResponse = ApiResponse<Planocontas_DestroyResponseDados>;

registerResponseContract('Planocontas_DestroyResponse', {
  id:      { type: 'number',  required: false },
  deleted: { type: 'boolean', required: true },
})
